import React, { useState, useEffect, useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaPlus, FaTrashAlt } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import Highlighter from "react-highlight-words";
import { useNavigate } from "react-router-dom";

import { Button, ScreenContainer, Text, Input, Table, ComboBox, Checkbox } from "components";

import { actionArticleDelete, actionArticlesGetAll, selectArticlesState, actionChangePage, actionChangeFilter, actionChangeFamId, actionChangeArtActivo } from "./redux";

import { CONSTANTS_COLORS } from "config/constants/Colors";
import { BUTTON_CONFIG } from "config/constants/Button";
import ArticlesLang from "./lang";
import ConfirmationModal from "components/ConfirmationModal";

import { actionFamiliesGetAll, selectAllFamilies } from "pages/families";


const ArticlesList = () => {
  const oDispatch = useDispatch();
  const oNavigator = useNavigate();

  const { aArticles, nPage, sFilter, nPages, nRecords } = useSelector(selectArticlesState);

  const [bIsDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [oArticleToDelete, setArticleToDelete] = useState(null);

  const aFamilies = useSelector(selectAllFamilies);
  const { nFamId, nArtActivo } = useSelector(selectArticlesState);


  useEffect(() => {
    oDispatch(actionArticlesGetAll());
    oDispatch(actionFamiliesGetAll());
  }, []);

  const onChangeTimeout = (oState, oData) => {
    if (!oData) { return oState; }
    if (oState) { clearTimeout(oState); }
    return oData;
  };

  const [, setTimer] = useReducer(onChangeTimeout, null);

  const onChangePage = (nSelectedPage) => {
    oDispatch(actionChangePage(nSelectedPage));
    oDispatch(actionArticlesGetAll());
  };

  const onChangeFilter = (sNewFilter) => {
    oDispatch(actionChangeFilter(sNewFilter));
    setTimer(setTimeout(() => {
      oDispatch(actionChangePage(1));
      oDispatch(actionArticlesGetAll());
    }, 800));
  };

  const onChangeFamId = (oFam) => {
    oDispatch(actionChangeFamId(oFam?.id || 0));
    oDispatch(actionChangePage(1));
    oDispatch(actionArticlesGetAll());
  };

  const onChangeArtActivo = (nValue) => {
    oDispatch(actionChangeArtActivo(nValue));
    oDispatch(actionChangePage(1));
    oDispatch(actionArticlesGetAll());
  };

  const onNavigate = () => {
    oNavigator("/articles/new");
  };

  const onUpdate = oArticle => {
    oNavigator(`/articles/${oArticle.id}`);
  };

  const onDelete = oArticle => {
    setArticleToDelete(oArticle);
    setIsDeleteModalOpen(true);
  };

  const onConfirmDelete = () => {
    setIsDeleteModalOpen(false);
    setArticleToDelete(null);
    oDispatch(actionArticleDelete(oArticleToDelete.id));
  };

  return (
    <ScreenContainer>
      <section className="grid grid-cols-2">
        <h1 className="ui-page-title self-center">
          {ArticlesLang.Labels.listArticles}
        </h1>
        <Button
          label={ArticlesLang.Buttons.new}
          onClick={onNavigate}
          containerClassName="ml-auto"
          className="flex align-middle"
          type={BUTTON_CONFIG.CLASS.SUCCESS}
          icon={<FaPlus size={20} color={CONSTANTS_COLORS.COLORS.WHITE_COLOR} className="ml-2" />}
        />
      </section>
      <section className="grid grid-cols-1 md:grid-cols-3 mt-4 gap-4">
        <div className="col-span-1">
          <label className="block text-sm text-gray-500 dark:text-gray-400 mb-1">Código / Nombre</label>
          <input
            type="text"
            value={sFilter}
            onChange={(e) => onChangeFilter(e.target.value)}
            placeholder="Buscar..."
            className="ui-field w-full"
          />
        </div>
        <ComboBox
          size="sm"
          label="Familia"
          emptyLabel="Todas las familias"
          options={[
            { label: "Todas las familias", value: 0, id: 0 },
            ...(aFamilies?.map(f => ({ ...f, label: f.name, value: f.id })) ?? []),
          ]}
          selected={nFamId === 0
            ? { label: "Todas las familias", value: 0 }
            : aFamilies?.find(f => f.id === nFamId)
              ? { label: aFamilies.find(f => f.id === nFamId).name, value: nFamId }
              : null}
          onChange={onChangeFamId}
        />
        <div className="col-span-1">
          <ComboBox
            size="sm"
            label="Estado"
            emptyLabel="Estado"
            options={[
              { label: "Activos", value: 1 },
              { label: "Inactivos", value: 0 },
            ]}
            selected={{ label: nArtActivo === 1 ? "Activos" : nArtActivo === 0 ? "Inactivos" : "Todos", value: nArtActivo }}
            onChange={(oItem) => onChangeArtActivo(oItem?.value ?? 1)}
          />
        </div>
      </section>





      <section className="py-5">
        <Table data-testid={"usersTable"}>
          <Table.Header>
            <Table.Row isHeaderOrFooter>
              <Table.Col scope="col" className="px-3 py-2">
                #
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-center hidden md:table-cell">
                {ArticlesLang.Fields.code}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-center hidden md:table-cell">
                {ArticlesLang.Fields.name}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-center hidden md:table-cell">
                {ArticlesLang.Fields.isActive}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-center hidden md:table-cell">
                {ArticlesLang.Fields.marca}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-center hidden md:table-cell">
                {ArticlesLang.Fields.model}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-right hidden md:table-cell">
                {ArticlesLang.Fields.stock}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-right hidden md:table-cell">
                {ArticlesLang.Fields.minStock}
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-right hidden md:table-cell">
                Precio
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-center" />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {aArticles.length > 0 ? (
              aArticles.map((oArticle, nIndex) => (
                <Table.Row
                  key={oArticle.id}
                  className="cursor-pointer"
                  onClick={() => onUpdate(oArticle)}
                >
                  <Table.Col
                    scope="row"
                    className="text-xs md:text-sm px-3 py-2 font-medium text-gray-800 dark:text-white whitespace-nowrap"
                  >
                    {nIndex + 1}
                  </Table.Col>
                  <Table.Col className="px-3 py-2 text-center hidden md:table-cell">
                    <Highlighter
                      searchWords={[sFilter]}
                      autoEscape={true}
                      textToHighlight={oArticle.code}
                    />
                  </Table.Col>
                  <Table.Col className="px-3 py-2 text-center hidden md:table-cell">
                    <Highlighter
                      searchWords={[sFilter]}
                      autoEscape={true}
                      textToHighlight={oArticle.name}
                    />
                  </Table.Col>
                  <Table.Col className="px-2 md:px-6 text-center">
                    {oArticle.isActive ? "Activo" : "Inactivo"}
                  </Table.Col>
                  <Table.Col className="px-2 md:px-6 text-center">
                    <Highlighter
                      searchWords={[sFilter]}
                      autoEscape={true}
                      textToHighlight={oArticle.marca}
                    />
                  </Table.Col>
                  <Table.Col className="px-2 md:px-6 text-center">
                    <Highlighter
                      searchWords={[sFilter]}
                      autoEscape={true}
                      textToHighlight={oArticle.model}
                    />
                  </Table.Col>
                  <Table.Col className="px-2 md:px-6 text-right hidden md:table-cell">
                    {oArticle.stock ?? "0"}
                  </Table.Col>
                  <Table.Col className="px-2 md:px-6 text-right hidden md:table-cell">
                    {oArticle.minStock}
                  </Table.Col>
                  <Table.Col className="px-2 md:px-6 text-right hidden md:table-cell">
                    {oArticle.price !== null
                      ? `${oArticle.priceCurrency} ${oArticle.price.toFixed(2)}`
                      : "-"}
                  </Table.Col>
                  <Table.Col className="text-center px-2">
                    <div className="flex justify-center">
                      <Button
                        onClick={(e) => {
                          e.stopPropagation();
                          onDelete(oArticle);
                        }}
                        size={BUTTON_CONFIG.SIZE.SM}
                        type={BUTTON_CONFIG.CLASS.DANGER}
                        icon={<FaTrashAlt size={16} color={CONSTANTS_COLORS.COLORS.WHITE_COLOR} />}
                      />
                    </div>
                  </Table.Col>
                </Table.Row>
              ))
            ) : (
              <Table.Row>
                <Table.Col className="px-3 py-2 text-center" colSpan={9}>
                  <em>No existen datos de artículos</em>
                </Table.Col>
              </Table.Row>
            )}
          </Table.Body>
          <Table.Footer>
            <Table.Row isHeaderOrFooter>
              <Table.Col colSpan="4" className="px-3 py-2 text-center md:hidden">
                <Table.Pagination total={nPages} page={nPage} onChange={onChangePage} records={nRecords} />
              </Table.Col>
            </Table.Row>
            <Table.Row isHeaderOrFooter>
              <Table.Col colSpan="4" className="px-3 py-2 text-center md:text-left">
                <Text>Total: {nRecords || "0"}</Text>
              </Table.Col>
              <Table.Col colSpan="5" className="px-3 py-2 text-right hidden md:table-cell">
                <Table.Pagination total={nPages} page={nPage} onChange={onChangePage} records={nRecords} />
              </Table.Col>
            </Table.Row>
          </Table.Footer>
        </Table>
      </section>
      <ConfirmationModal
        show={bIsDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={onConfirmDelete}
        title="Eliminar artículo"
        question={`Está seguro que desea eliminar el artículo ${oArticleToDelete?.name}`}
        message="Esta acción no se puede revertir"
      />
    </ScreenContainer>
  );
};

export default ArticlesList;
